import type { IconNode } from '../types';

/**
 * @name lingerie
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNSAydjJhMiAyIDAgMCAwLTIgMnYyYzAgMS43IDEuMyAzIDMgM2gyYTIgMiAwIDAgMCAyLTJoNGEyIDIgMCAwIDAgMiAyaDJjMS43IDAgMy0xLjMgMy0zVjZhMiAyIDAgMCAwLTItMiIgLz4KICA8cGF0aCBkPSJNMTAgOWMwLTIuOC0yLjItNS01LTUiIC8+CiAgPHBhdGggZD0iTTE5IDJ2MmMtMi44IDAtNSAyLjItNSA1IiAvPgogIDxwYXRoIGQ9Ik0zIDE1YTcgNyAwIDAgMSA3IDdoNGE3IDcgMCAwIDEgNy03WiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/lingerie
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const lingerie: IconNode = [
  [
    'path',
    {
      d: 'M5 2v2a2 2 0 0 0-2 2v2c0 1.7 1.3 3 3 3h2a2 2 0 0 0 2-2h4a2 2 0 0 0 2 2h2c1.7 0 3-1.3 3-3V6a2 2 0 0 0-2-2',
      key: '1hhdpn',
    },
  ],
  ['path', { d: 'M10 9c0-2.8-2.2-5-5-5', key: '1u1kcp' }],
  ['path', { d: 'M19 2v2c-2.8 0-5 2.2-5 5', key: '17dbq1' }],
  ['path', { d: 'M3 15a7 7 0 0 1 7 7h4a7 7 0 0 1 7-7Z', key: '1uqftu' }],
];

export default lingerie;
